import { NonContentBlocks } from 'common/builder/components/chart/FlowChart/lib/constants/NonContentBlocks'
import { FlowChartBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartBlock'

/**
 * Sorts content node blocks so that non-content blocks are at the end of the list.
 * Example of noncontent blocks: QuickReplies, Telegram Keyboard
 */
export const sortContentNodeBlocks = (blockA: FlowChartBlock, blockB: FlowChartBlock) => {
  const aIsNonContent = NonContentBlocks.includes(blockA.type)
  const bIsNonContent = NonContentBlocks.includes(blockB.type)

  if (aIsNonContent === bIsNonContent) {
    return 0
  }

  if (aIsNonContent) {
    return 1
  }

  if (bIsNonContent) {
    return -1
  }

  return 0
}
